import { render, staticRenderFns } from "./RespContent.vue?vue&type=template&id=738c8da0"
import script from "./RespContent.vue?vue&type=script&lang=js"
export * from "./RespContent.vue?vue&type=script&lang=js"
import style0 from "./RespContent.vue?vue&type=style&index=0&id=738c8da0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports